import React, { useState } from 'react';

const FilterModal = ({
  isOpen,
  onClose,
  onApply,
  checkboxProps,
  checkboxStates,
  setCheckboxStates,
}) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleCheckboxChange = (id) => {
    setCheckboxStates(id);
  };

  return (
    isOpen && (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-96 transition-colors">
          <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
            Filter by Date
          </h2>
          <div className="grid grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Start Date
              </label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm p-2 focus:ring-primary focus:border-primary bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                End Date
              </label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm p-2 focus:ring-primary focus:border-primary bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              />
            </div>
          </div>

          <div className="flex flex-col gap-3 mb-4">
            {checkboxProps.map((checkbox) => (
              <div
                key={checkbox.id}
                className="flex items-center ps-4 cursor-pointer shadow-sm rounded-md border border-gray-200 dark:border-gray-700 py-3 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
              >
                <input
                  type="checkbox"
                  id={checkbox.id}
                  checked={checkboxStates === checkbox.id ? true : false}
                  name="checkbox"
                  onChange={() => handleCheckboxChange(checkbox.id)}
                  className="w-4 h-4 text-primary bg-gray-100 dark:bg-gray-700 cursor-pointer border-gray-300 dark:border-gray-600 rounded focus:ring-primary"
                />
                <label
                  htmlFor={checkbox.id}
                  className="ml-2 text-sm font-medium cursor-pointer text-gray-900 dark:text-gray-200"
                >
                  {checkbox.label}
                </label>
              </div>
            ))}
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={() => {
                onClose();
              }}
              className="px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={() => onApply(startDate, endDate, checkboxStates)}
              className="px-4 py-2 bg-primary-600 hover:bg-primary-700 font-medium shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 text-white rounded-md transition-colors"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default FilterModal;
